var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 82,
    height: 82,
    rx: 41,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.0325 32.08H49.5365V44.416C49.5365 46.384 50.4005 47.056 51.6005 47.056C54.0965 47.056 54.6725 42.736 54.6725 40.24C54.6725 32.8 48.9125 27.328 40.9925 27.328C33.0725 27.328 27.3125 33.184 27.3125 41.2C27.3125 49.216 32.9285 55.072 40.7045 55.072C43.5845 55.072 46.0325 54.4 47.4725 53.392H53.0885C50.4965 56.368 46.6085 58.48 40.7045 58.48C30.7205 58.48 23.4725 51.184 23.4725 41.2C23.4725 31.216 30.8645 23.92 40.9925 23.92C51.1205 23.92 58.5125 30.784 58.5125 40.24C58.5125 45.328 56.2085 50.8 51.1685 50.8C49.5365 50.8 47.7125 50.032 46.8965 48.208C45.5525 50.032 42.8165 50.8 41.1365 50.8C35.5685 50.8 31.5365 46.768 31.5365 41.2C31.5365 35.632 35.3765 31.6 40.6565 31.6C42.7685 31.6 44.7845 32.608 46.0325 33.904V32.08ZM40.8005 47.056C43.8725 47.056 46.1285 44.608 46.1285 41.2C46.1285 37.792 43.8725 35.344 40.8005 35.344C37.7285 35.344 35.4725 37.792 35.4725 41.2C35.4725 44.608 37.7285 47.056 40.8005 47.056Z",
    fill: "#171717"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAt);
export default __webpack_public_path__ + "static/media/At.367aeccb1a84c422bca5eb312fec09e1.svg";
export { ForwardRef as ReactComponent };